import React from 'react';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';


const ProfileSelector = ({ profiles, selectedProfile, onProfileChange, className = '' }) => {
  const profileOptions = profiles.map(profile => ({
    value: profile.id,
    label: profile.title,
    description: `${profile.duration} • ₹${profile.fee.toLocaleString('en-IN')}`
  }));

  const selectedProfileData = profiles.find(p => p.id === selectedProfile);

  return (
    <div className={`space-y-6 ${className}`}>
      {/* Profile Dropdown */}
      <div>
        <Select
          label="Select Your Career Path"
          description="Choose the program that aligns with your career goals"
          placeholder="Select a training program..."
          options={profileOptions}
          value={selectedProfile}
          onChange={onProfileChange}
          searchable={false}
          clearable={false}
          required
        />
      </div>

      {/* Selected Profile Details */}
      {selectedProfileData && (
        <div className="bg-primary/5 border border-primary/20 rounded-lg p-6">
          <div className="flex items-start space-x-4">
            <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center flex-shrink-0">
              <Icon name={selectedProfileData.icon} size={24} color="white" strokeWidth={2} />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-foreground mb-2">
                {selectedProfileData.title}
              </h3>
              <p className="text-sm text-text-secondary mb-4">
                {selectedProfileData.description}
              </p>
              
              {/* Quick Details */}
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <span className="text-xs font-medium text-text-secondary uppercase tracking-wide">
                    Duration
                  </span>
                  <div className="text-sm font-medium text-foreground">
                    {selectedProfileData.duration}
                  </div>
                </div>
                <div>
                  <span className="text-xs font-medium text-text-secondary uppercase tracking-wide">
                    Registration Fee
                  </span>
                  <div className="text-lg font-bold text-primary">
                    ₹{selectedProfileData.fee.toLocaleString('en-IN')}
                  </div>
                </div>
              </div>

              {/* Key Highlights */}
              <div>
                <span className="text-xs font-medium text-text-secondary uppercase tracking-wide mb-2 block">
                  Program Highlights
                </span>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                  {selectedProfileData.benefits.slice(0, 4).map((benefit, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <div className="w-1.5 h-1.5 bg-primary rounded-full flex-shrink-0"></div>
                      <span className="text-sm text-text-secondary">{benefit}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileSelector;
